export const editarVenda = 'EditarVenda';
export const listarVendas = 'ListarVendas';
export const exportarVendas = 'ExportarListaVendas';
export const excluirVenda = 'ExcluirVenda';

export const vendas = [editarVenda, listarVendas, exportarVendas, excluirVenda];
